export default {
  tileTitle: {
    en: "Wallet",
    ja: "ウォレット"
  },

  checkBSCNetwork: {
    en: "I confirm that this address is in Binance Smart Chain (BSC) network.",
    ja: "このアドレスが Binance Smart Chain (BSC) ネットワークにあることを確認しました。"
  },

  walletPlaceholder: {
    en: "Wallet address",
    ja: "ウォレットアドレス"
  },

  incorrectAddressWarning: {
    en: "Please enter a correct address",
    ja: "正しい住所を入力してください"
  }
}
